import { render } from "./Input.vue?vue&type=template&id=b37ec466"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__